import { TextButton } from '@wix/design-system';
import { SearchCodeSmall as SearchCodeSmallIcon } from '@wix/wix-ui-icons-common';
import React from 'react';
import { useTranslation } from '../hooks';
export const ViewAllDetailsButton = _ref => {
  let {
    onClick
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    onClick: onClick,
    prefixIcon: /*#__PURE__*/React.createElement(SearchCodeSmallIcon, null)
  }, t('view-details.button'));
};
//# sourceMappingURL=ViewAllDetailsButton.js.map